import EditorFrame from './EditorFrame';

export default EditorFrame;
